import Filter from './Filter.js';
import { ChangeEvent } from './ChangeEvent';

/**
 * Handles Dropdown creation
 */
class Custom extends Filter {
  constructor(containerId, searchParameter, options, updateCallback, searchParameters) {
    super({ containerId, searchParameter, options, updateCallback, searchParameters });
    this.container = document.getElementById(containerId);
    this.placeholder = this.container.dataset.placeholder;
    this.key = this.container.dataset.key;
    this.ui = this.container.dataset.ui;
  }

  create() {}

  changeValue(value) {
    if (this.updateCallback && typeof this.updateCallback === 'function') {
      // Use the optional value argument on `updateCallback` because
      // this.searchParameters is likely to be an outdated reference.
      this.updateCallback(this.searchParameter, value ?? '');
    }
  }

  update() {
    // Prevent adding event listeners multiple times.
    if (this.container.dataset.isSetUp) {
      return;
    }
    this.container.dataset.isSetUp = true;

    const filter = this;

    const changeEventNames = (filter.container.dataset.changeEvent ?? 'change').split(',');
    changeEventNames.forEach((changeEventName) =>
      filter.container?.addEventListener(changeEventName, (e) => {
        // Allow the filter to define custom handling.
        if (
          filter.container.handleChangeEvent &&
          typeof filter.container.handleChangeEvent === 'function'
        ) {
          filter.container.handleChangeEvent(changeEventName, e, filter);

          // Try some generic handling if the event has an accessible value.
        } else if (e?.target?.value) {
          this.changeValue(e.target.value);
        }

        // Repeat the event as a dspFilter.change event, for extra compatibility.
        filter.container.dispatchEvent(new ChangeEvent(e.target, e));
      }),
    );
  }
}

export default Custom;
